<template>
  <div class="container">
    <div v-wechat-title="active == 1 ? '我的粉丝' : '我的关注'"></div>
    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="active"
        title-active-color="#EB4E4E"
        line-width="50px"
        line-height="2px"
        @change="typeClick"
      >
        <van-tab title="我的关注"></van-tab>
        <van-tab title="我的粉丝"></van-tab>
      </van-tabs>
    </div>

    <div class="contentBox">
      <van-list
        v-if="active == 0"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getFollowListHandle"
      >
        <div v-for="(item, index) in followsList" :key="index">
          <div class="contentItem">
            <div class="leftBox" @click.stop="toHomePage(item.FollowMemberId)">
              <van-image
                fit="cover"
                :src="item.Photo"
                round
                error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
              />
              <div class="nameBox">
                <div class="name van-ellipsis">{{ item.Headline }}</div>
                <div class="dec van-ellipsis">{{ item.Introduction }}</div>
                <div class="dec van-ellipsis" style="margin-bottom: 0">
                  {{ item.FollowTotal }}粉丝
                </div>
              </div>
            </div>
            <div
              class="btnBox"
              @click.stop="cancelHandle(index, item.FollowMemberId)"
            >
              <div
                class="iconfont icon-seleted"
                style="color: #999; font-size: 12px; margin-right: 5px"
              ></div>
              已关注
            </div>
          </div>
        </div>
      </van-list>

      <van-list
        v-if="active == 1"
        v-model="nloading"
        :finished="nfinished"
        :error.sync="nerror"
        error-text="请求失败，点击重新加载"
        :immediate-check="false"
        @load="getFansListHandle"
      >
        <div v-for="(item, index) in fansList" :key="index">
          <div class="contentItem">
            <div class="leftBox" @click.stop="toHomePage(item.MemberId)">
              <van-image
                fit="cover"
                :src="item.Photo"
                round
                error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
              />
              <div class="nameBox">
                <div class="name van-ellipsis" style="margin-bottom: 7px">
                  {{ item.Headline }}
                </div>
                <div class="dec van-ellipsis" style="margin-bottom: 0">
                  {{ item.FollowTotal }}粉丝
                </div>
              </div>
            </div>
            <div
              class="btnBox"
              @click.stop="cancelHandle(index, item.MemberId)"
              v-if="item.AddTwo"
            >
              <div
                class="iconfont icon-mutual"
                style="color: #999; font-size: 14px; margin-right: 5px"
              ></div>
              互相关注
            </div>
            <div
              class="btnBox"
              style="color: #fff; background: #eb4e4e; border: 0"
              @click.stop="addHandle(index, item.MemberId)"
              v-else
            >
              <div
                class="iconfont icon-add"
                style="font-size: 11px; margin-right: 5px"
              ></div>
              关注
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div
      class="noDataBox"
      v-if="
        (active == 0 && followsList.length == 0) ||
        (active == 1 && fansList.length == 0)
      "
    >
      <span class="iconfont icon-kong"></span>
      <div>什么也没有！</div>
    </div>
  </div>
</template>
<script>
import { List, Tab, Tabs, Image } from "vant";
import {
  memberFollowsList,
  memberFansList,
  unFollowMember,
  followMember,
} from "@/api/member";
export default {
  name: "myAttention",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      active: 0,
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      followsList: [],

      nloading: false,
      nfinished: false,
      ntotal: 0,
      npageIndex: 1,
      nerror: false,
      fansList: [],
    };
  },
  methods: {
    typeClick(name) {
      this.active = name;
      if (this.active == 0) {
        this.fansList = [];
        this.pageIndex = 1;
        this.loading = true;
        if (this.loading) {
          this.getFollowListHandle();
        }
      } else {
        this.followsList = [];
        this.npageIndex = 1;
        this.nloading = true;
        if (this.nloading) {
          this.getFansListHandle();
        }
      }
    },

    //个人主页
    toHomePage(mid) {
      this.$router.push({ path: "/homePage", query: { mid: mid } });
    },

    //取消关注
    cancelHandle(idx, id) {
      var that = this;
      var data = {
        MemberId: id,
      };
      unFollowMember(data).then((res) => {
        if (that.active == 0) {
          var followsList = that.followsList;
          followsList.splice(idx, 1);
          this.followsList = followsList;
        } else {
          this.fansList.forEach(function (item, index) {
            if (idx == index) {
              item.AddTwo = false;
            }
          });
        }
      });
    },

    //添加关注
    addHandle(idx, id) {
      var that = this;
      var data = {
        MemberId: id,
      };
      followMember(data).then((res) => {
        this.fansList.forEach(function (item, index) {
          if (idx == index) {
            item.AddTwo = true;
          }
        });
      });
    },

    //获取我的关注
    getFollowListHandle() {
      var that = this;
      var data = {
        Keyword: "",
        MemberId: 0,
        Page: {
          PageIndex: that.pageIndex,
          PageSize: 10,
        },
      };
      memberFollowsList(data).then((res) => {
        if (that.pageIndex == 1) {
          that.followsList = [...res.Data.List];
        } else {
          that.followsList = [...that.followsList, ...res.Data.List];
        }
        that.total = res.Data.Total;
        that.pageIndex += 1;
        that.loading = false;
        if (that.followsList.length >= that.total) {
          that.finished = true;
        }
      });
    },

    //获取我的粉丝
    getFansListHandle() {
      var that = this;
      var data = {
        Keyword: "",
        MemberId: 0,
        Page: {
          PageIndex: that.npageIndex,
          PageSize: 10,
        },
      };
      memberFansList(data).then((res) => {
        if (that.npageIndex == 1) {
          that.fansList = [...res.Data.List];
        } else {
          that.fansList = [...that.fansList, ...res.Data.List];
        }
        that.ntotal = res.Data.Total;
        that.npageIndex += 1;
        that.nloading = false;
        if (that.fansList.length >= that.ntotal) {
          that.nfinished = true;
        }
      });
    },
  },

  mounted() {
    if (this.$route.query.type == 1) {
      this.active = 1;
    } else {
      this.active = 0;
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background: #f5f5f5;
  .classifyNav {
    padding: 0 80px;
    background-color: white;
    margin-bottom: 10px;
    /deep/ [class*="van-hairline"]::after {
      border: none;
    }
  }
}

.contentBox {
  background: #fff;
  display: flex;
  flex-direction: column;
  .contentItem {
    height: 85px;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    border-bottom: 1px solid #e4e4e4;
    padding: 0 12px 0 15px;
    justify-content: space-between;
    align-items: center;
    .leftBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      .van-image {
        display: block;
        width: 50px;
        height: 50px;
        margin-right: 13px;
      }
      .nameBox {
        width: 185px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .name {
          font-size: 12px;
          color: #333;
          margin-bottom: 10px;
          width: 185px;
        }
        .dec {
          font-size: 10px;
          color: #999;
          margin-bottom: 5px;
        }
      }
    }
    .btnBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 85px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 3px;
      font-size: 11px;
      color: #666;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      -ms-border-radius: 3px;
      -o-border-radius: 3px;
    }
  }
}
</style>

